import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../../../../component/shared/shared.service';
import { AppointmentService } from '../../../appointment/service/appointment.service';
import { VitalSignService } from '../../service/vital-sign.service';
import { Patient} from '../../model/patient';
import { VitalSign} from '../../model/vital-sign';
import { Appointment } from '../../../appointment/model/appointment';
import { PatientService } from '../../service/patient-service.service';
import { DialogAction, ActionMessage } from '../../../../shared/enum/dialog-action.enum';
@Component({
  selector: 'app-vital-sign',
  templateUrl: './vital-sign.component.html',
  styleUrls: ['./vital-sign.component.css'] 
})
export class VitalSignComponent implements OnInit {
  isAdd : boolean = false;
  isEdit: boolean = false;
  isErrorMessage : boolean = false;
  isSuccessMessage : boolean = false;
  patientInfo : Patient;
  Aloading : boolean = false;
  message : string;
  @Input() patient : Patient ;
  appointments : Appointment[];
  selectedAppointment : Appointment;
  appdata : number = null;
  vitalData : VitalSign;
  vitalList : VitalSign[];
  user:any;
  constructor(private _sharedService: SharedService, private _usrService : PatientService, private _vitalSrv : VitalSignService) { 
    
    _sharedService.yesEmitted$.subscribe(
      text => {
          if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'VITALSIGN') {
             this.deleteVitalData();
          }  
      });
       this._usrService.text$.subscribe(data=>{
         if(data.length>0) {
          this.appointments = data;
          this.selectedAppointment = this.appointments[0];
          this.appdata = this.appointments[0].AppointmentId;
          this.vitalData = new VitalSign(this.patient.PatientId, '', '', '', '', '', '', this.appdata,null,'','')
        
         }
       })
  }

  addVitalSign() {
    var appId  = parseInt(this.appdata.toString());
    var appDataObj = this.appointments.filter(function(usr) {
       return (usr.AppointmentId===appId)
    })
    this.vitalData.AppointmentId = appId;
    this.vitalData.AppointmentDay = appDataObj[0].AppointmentDay;
    this.vitalData.AppointmentTime = appDataObj[0].AppointmentTime;
    this._vitalSrv.vitalData = this.vitalData;
    this._vitalSrv.saveVitalSign().subscribe(data=>{
        this.message = "Vital Sign saved successfully";
        this.isSuccessMessage = true;
        this.Aloading = false;
        this.hideMessage();
        this.cancelOperation() ;
        this.getVitalSign();
    },
    error=>{
      this.message = error.data;
      this.isErrorMessage = true;
      this.Aloading = false;
      this.hideMessage();
      
    });
  }
  updateVitalSign() {
    this._vitalSrv.vitalData = this.vitalData;
    this._vitalSrv.updateVitalSign().subscribe(data=>{
        this.message = "Vital Sign updated successfully";
        this.isSuccessMessage = true;
        this.Aloading = false;
        this.hideMessage();
        this.cancelOperation() ;
        this.getVitalSign();
    },
    error=>{
      this.message = error.data;
      this.isErrorMessage = true;
      this.Aloading = false;
      this.hideMessage();
      
    });
  }
  saveVitalSign() : void {
    this.Aloading = true;
    if(this.isAdd) {
      this.addVitalSign();
    } 
    if(this.isEdit) {
      this.updateVitalSign();
    }
   
  }

  cancelOperation() : void {
     this.isAdd = false;
     this.vitalData.BloodPressure = '';
     this.vitalData.PatientWeight = '';
     this.vitalData.Pulse = '';
     this.vitalData.RespiratoryRate = '';
     this.vitalData.Temperature = '';
     this.isEdit = false;
  }
  deleteVital(data : VitalSign) {
    this.vitalData = data;
    this._sharedService.emitDialog(true, "Delete", ActionMessage.DELETE.toString(),true,DialogAction.DELETE.toString(), 'VITALSIGN' );      
    
  }
  deleteVitalData() {
    this._vitalSrv.deleteVitalSign(this.vitalData).subscribe(data=>{
      this.message = "Vital Sign delete successfully";
      this.isSuccessMessage = true;
      this.Aloading = false;
      this.hideMessage();
      this.cancelOperation() ;
      this.getVitalSign();
  },
  error=>{
    this.message = error.data;
    this.isErrorMessage = true;
    this.Aloading = false;
    this.hideMessage();
    
  });
  }
  editVital(vitalobj : VitalSign) {
    this.isEdit = true;
    this.vitalData = JSON.parse(JSON.stringify( vitalobj));
  }

  hideMessage() : void {
    setTimeout(() => {
      this.isErrorMessage  = false;
      this.isSuccessMessage  = false;   
      this.message = '';
    }, 1000);
  }
  getVitalSign() : void {
    this.Aloading = true;
    this.vitalList = [];
    this._vitalSrv.getVitalSign(this.patient.PatientId).subscribe(data=>{
        this.vitalList = data;
        this.Aloading = false;
        this.hideMessage();
    },
    error=>{
      this.Aloading = false;
    });
  }
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    this.getVitalSign();
  }
  ngOnChanges() {
    this.getVitalSign();
  }
}



// WEBPACK FOOTER //
// ./src/app/section/patient/view-patient-profile/vital-sign/vital-sign.component.ts